import { createTheme } from '@mui/material/styles';
import { createBreakpoints } from '@mui/system';
import ThemeBreakpoints from './overrides/Breakpoints';
import MuiAppBar from './overrides/MuiComponents/MuiAppBar';
import MuiButton from './overrides/MuiComponents/MuiButton';
import MuiButtonBase from './overrides/MuiComponents/MuiButtonBase';
import MuiStepButton from './overrides/MuiComponents/MuiStepButton';
import MuiGrid from './overrides/MuiComponents/MuiGrid';
import MuiSelect from './overrides/MuiComponents/MuiSelect';
import MuiSvgIcon from './overrides/MuiComponents/MuiSvgIcon';
import MuiTypography from './overrides/MuiComponents/MuiTypography';
import MuiStepConnector from './overrides/MuiComponents/MuiStepConnector';
import MuiStepLabel from './overrides/MuiComponents/MuiStepLabel';
import MuiTextField from './overrides/MuiComponents/MuiTextField';
import MuiMenuItem from './overrides/MuiComponents/MuiMenuItem';
import palette from './overrides/Palette';

const breakpoints = createBreakpoints(ThemeBreakpoints);

export default createTheme({
  breakpoints,
  palette,
  components: {
    MuiAppBar: MuiAppBar(breakpoints),
    MuiButton: MuiButton(breakpoints),
    MuiButtonBase,
    MuiGrid,
    MuiSelect,
    MuiStepButton,
    MuiSvgIcon,
    MuiTypography: MuiTypography(breakpoints),
    MuiStepConnector: MuiStepConnector(breakpoints),
    MuiStepLabel,
    MuiTextField: MuiTextField(breakpoints),
    MuiMenuItem,
  },
});
